import { Component, OnDestroy, OnInit } from '@angular/core';
import * as sharedModels from '@shared/models';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { AddressService, DictionaryService } from '@shared/services';
import { combineLatest, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RealPropertyListFilterService, ResidentialComplexService } from '@app/real-property-list-filter/services';
import { SettingsService } from '@app/settings.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, OnDestroy {
  public isHomePage = false;
  private destroy$: Subject<any> = new Subject<any>();

  constructor(
    private _addressService: AddressService,
    private _router: Router,
    private _dictService: DictionaryService,
    private realPropertyListFilterService: RealPropertyListFilterService,
    private _complexService: ResidentialComplexService,
    private _settingsService: SettingsService,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this._addressService.getCitiesList([sharedModels.AddressObjectTypeList.MainCity, sharedModels.AddressObjectTypeList.AreaCenterCity, sharedModels.AddressObjectTypeList.City]);

    this._addressService.cityLoaded$
      .pipe(
        filter((r) => r),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this._addressService.updateCurrentCity(1));

    this._settingsService.changeLocation$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.getDataAndRedirect(value);
    });
  }

  getDataAndRedirect(tab: 'list' | 'map' = null) {
    combineLatest([
      this._addressService.currentCity$,
      this._addressService.currentStreets$.pipe(map((st) => st.map((s) => s.code))),
      this._addressService.currentDistricts$.pipe(map((dt) => dt.map((s: any) => s.code))),
      this._dictService.currentHouseConditions$.pipe(map((st: any[]) => st.map((s) => s.id))),
      this._complexService.currentComplex$.pipe(map((st) => st.map((s: any) => s.id))),
      this._dictService.currentObjectTypeId$,
      this._settingsService.currentFilters$,
    ])
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(([city, street, district, condition, complex, objectTypes, filters]) => {
        const addressCode = street.length ? street : district.length ? district : [city.code];
        const data: any = {
          pageNumber: 0,
          pageSize: 20,
          operationTypeId: filters.dealType.value,
          applicationId: filters.proposalId,
          addressCodes: addressCode,
          objectTypeId: objectTypes,
          residentialComplexIds: complex,
          encumbrance: null,
          exchange: null,
          atelier: filters.layout,
          housingConditionIds: condition,
          direction: null,
          sortBy: null,
          numberOfRooms: filters.roominess,
          moreThanFiveRooms: null,
          probabilityOfBidding: null,
          objectPrice: {
            from: filters.price.from,
            to: filters.price.to,
          },
          totalArea: {
            from: filters.area.from,
            to: filters.area.to,
          },
          yearOfConstruction: {
            from: filters.constructYear.from,
            to: filters.constructYear.to,
          },
        };
        const dealType = filters.dealType.label === 'Покупка' ? 'buy' : 'rent';
        let url = '';
        if (tab) {
          url = '/' + (tab === 'map' ? '/map' : '/list');
        } else {
          url = '/' + (this._router.url.includes('map') ? '/map' : '/list');
        }
        url = url + `/${city.translateNames.nameEn}/${dealType}`;
        this.realPropertyListFilterService.setRoute(data, url);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
